export interface TruncationOptions {
	/**
	 * truncation configuration
	 */
	/**
	 * truncation type
	 */
	type?: string;
	/**
	 * truncation threshold
	 */
	threshold?: Number;
	/**
	 * how many characters to be shown
	 */
	numCharacter?: Number;
}
